import { EDIT_ANSWER, SAVE_ANSWER } from "../answers/actions";


export const editAnswerId = (state = null, action) => {
    switch (action.type) {
        case EDIT_ANSWER:
            return action.answer ? action.answer.id : null

        case SAVE_ANSWER:
            return null

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/editAnswerId/index.js